import { useEffect, useState } from 'react';
import { getDayParts } from '../pages/students/rescheduleApi';

// Module-scoped cache - the 4 day-part ranges are fixed backend constants,
// no point re-fetching them every time a component using this hook mounts.
let cache = null;
let inFlight = null;

// Single source of truth for CRM-side day-part rendering (label + from-to
// range per id) - fetched from GET /api/day-parts rather than hardcoded, so
// a backend-side label tweak (already happened once) never needs a
// matching frontend deploy.
export default function useDayParts() {
   const [dayParts, setDayParts] = useState(cache || []);

   useEffect(() => {
      if (cache) { setDayParts(cache); return; }
      if (!inFlight) {
         inFlight = getDayParts().then((res) => {
            cache = Array.isArray(res.data) ? res.data : [];
            return cache;
         }).catch(() => []);
      }
      inFlight.then((data) => setDayParts(data || []));
   }, []);

   return dayParts;
}
